import { createRequest } from "../../tools";

export const createNewConnectionField = async (connection_id, field_mapping_id, data) => {
  return await createRequest({
    suffix: `lead/connection/${connection_id}/field-mapping/${field_mapping_id}/add`,
    method: "post",
    payload: data,
    handleError: false,
  });
};

export const updateConnectionComparedFields = async(connection_id, field_mapping_id, data) => {
  return await createRequest({
    suffix: `lead/connection/${connection_id}/field-mapping/${field_mapping_id}/compared_fields`,
    method: "post",
    payload: data,
    handleError: false,
  });
}

export const saveDynamicFields = async (data) =>
  createRequest({
    suffix: "lead/connection/dynamic-fields",
    method: "post",
    payload: data,
    handleError: true,
  });

export const getDynamicFields = async (connectionId) =>
  createRequest({
    suffix: `lead/connection/${connectionId}/dynamic-fields`,
    method: "get",
    handleError: true,
  });

export const updateDynamicField = async (dynamicFieldId, payload) =>
  createRequest({
    suffix: `lead/connection/dynamic-fields/${dynamicFieldId}`,
    method: "put",
    payload,
    handleError: true,
  });

export const deleteDynamicField = async (dynamicFieldId, force = false) =>
  createRequest({
    suffix: `lead/connection/dynamic-fields/${dynamicFieldId}${force ? "?force=true" : ""}`,
    method: "delete",
    handleError: true,
  });

export const updateNewConnectionField = async (connection_id, field_mapping_id, data) => {
  return await createRequest({
    suffix: `lead/connection/${connection_id}/field-mapping/${field_mapping_id}`,
    method: "post",
    payload: data,
    handleError: false,
  });
};
